import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ProgressBar } from "react-loader-spinner";

import UniversalInputComponent from "../../AdministrativeProcedures/commonComponents/universalInputComponent/UniversalInputComponent";
import AppFooterRHF from "../commonComponents/appFooterRHF/AppFooterRHF";
import UniversalHeader from "../commonComponents/universalHeader/UniversalHeader";
import ResultModalWindow from "../commonComponents/ResultModalWindow/ResultModalWindow";
import ButtonsBlock from "../../GeneralComponents/buttonsBlock/ButtonsBlock";
import QRModalWindow from "../commonComponents/QRModalWindow/QRModalWindow";
import InputsCreatorUniversal from "../../../hooks/inputCreatorUniversal";
import LoaderWithOverlay from "../../GeneralComponents/loaderWithOverlay/loaderWithOverlay";

import {
  exchangeCertificatesHeader,
  interestedPersonRepublican,
  interestedPersonInternational,
  representPerson,
  infoMedicalConditions,
  setOblOptionsFromDictionaries,
  setHeaderFieldsByCertificateType,
  setOptionsRepresentPerson,
  setGridsByMode,
  setDefaultOptionsRepresent,
  setDisabledButtonStatus,
  setDocOptionsRepresentFromDictionaries,
  isNeedToPaySelector,
  setMedicalConditionOptions,
} from "./optionsExchangeCertificatesAppRHF";

import {
  clearExchangeAppData,
  getCertificateInfoByNumExchange,
  getExchangeAppDataById,
} from "../../../redux/exchangeCertificatesReducer/actionsExchangeCertificates";

import {
  MAIN_URL,
  PORT,
  API_SAVE_EXCHANGE_CERTIFICATES_APP,
  API_GET_QR,
  PORT_FOR_INTEGRATION,
  API_GET_BILL,
  API_PRINT_EXCHANGE_CERTIFICATE_APP,
  API_SAVE_EXCHANGE_CERTIFICATES_APP_CHECK,
} from "../../../constants/constants";
import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import styles from "./exchangeCertificatesAppRHF.module.css";

export default function ExchangeCertificatesAppRHF() {
  const {
    register,
    unregister,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    getValues,
    trigger,
  } = useForm({ mode: "onChange" });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const mode = window.location.pathname.includes("/add/") ? "add" : "view";
  const downloadAPI = "https://gimc.by:8080/boats/file/download/attachment/";

  const [options, setOptions] = useState({
    header: exchangeCertificatesHeader,
    interested: window.location.pathname.includes("/republican")
      ? interestedPersonRepublican
      : interestedPersonInternational,
    represent: representPerson,
    medCondition: infoMedicalConditions,
  });
  const [newData, setNewData] = useState({
    appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
    licenseTypeId: (() =>
      mode === "add" ? (window.location.pathname.includes("/republican") ? 1 : 2) : "")(),
    licenseTypeIdName: (() =>
      mode === "add"
        ? window.location.pathname.includes("/republican")
          ? "Республиканское"
          : "Международное"
        : "")(),
    isNeedToPaySelector: false,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [file, setFile] = useState("");
  const [viewFileName, setViewFileName] = useState("");

  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [errorText, setErrorText] = useState("");
  const [headerText, setHeaderText] = useState("");

  const [showBillContractModal, setShowBillContractModal] = useState(false);
  const [serviceBill, setServiceBill] = useState(null);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isPrinted, setIsPrinted] = useState(false);

  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });
  const exchangeCertificatesReducer = useSelector((state) => {
    const { exchangeCertificatesReducer } = state;
    return exchangeCertificatesReducer;
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });

  const printAccess = useChapterActionIdMatch(
    sortedMenuNames?.EXCHAGE_CERTIFICATES?.printApplication?.chapterActionId,
  );

  const resolveSubmit = async (data) => {
    const { address, surname, name, midname, phone } = newData;
    const { isNeedToPaySelector } = getValues();
    if (!isNeedToPaySelector) {
      saveApplication(data, false);
      return;
    }

    if (await saveApplication(data, true)) {
      const createdBill = await fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_BILL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          address,
          surname,
          name,
          midname,
          programId: null,
          phone,
          paidProcType: null,
          codeNumber: "200010",
        }),
      }).then((res) => res.json());

      if (!createdBill.id) {
        setErrorText("Зарегистрируйте заявление без выставления счёта на оплату или попробуйте позже.");
        setHeaderText(createdBill.message);
        setShowResultModal(!showResultModal);
      } else {
        setHeaderText("");
      }

      if (createdBill.id) {
        fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_QR, {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify({
            serviceBillId: createdBill.serviceBillId,
          }),
        })
          .then((res) => res.blob())
          .then((blob) => {
            setServiceBill({
              id: createdBill.serviceBillId,
              QRurl: URL.createObjectURL(blob),
              onClose: () => {
                saveApplication({ ...data, billDataId: createdBill.id }, false);
                setShowBillContractModal(false);
              },
            });
            setShowBillContractModal(true);
          });
      }
    }
  };

  const saveApplication = async (data, check) => {
    const formData = new FormData();
    const newStatement = { ...newData, ...data };
    for (const key in newStatement) {
      if (key.includes("Date") && key !== "appDate") {
        newStatement[key] =
          newStatement[key] && newStatement[key].includes("-")
            ? newStatement[key].split("-").reverse().join(".")
            : newStatement[key];
      }
    }
    delete newStatement.validVal;
    delete newStatement.validZoneId;
    delete newStatement.validTypeId;
    formData.append("data", JSON.stringify(newStatement));
    if (file !== undefined && file !== null) {
      formData.append(`file`, file);
    }
    const api = check ? API_SAVE_EXCHANGE_CERTIFICATES_APP_CHECK : API_SAVE_EXCHANGE_CERTIFICATES_APP;
    const request = await fetchWithToken(MAIN_URL + PORT + api, {
      method: "POST",
      body: formData,
    });

    if (request.status !== 200) {
      setShowResultModal(!showResultModal);
      setRegistrationResult("error");
      if (check) return false;
    } else {
      if (check) return true;
      const response = await request.text();
      setAppId(response);
      setShowResultModal(!showResultModal);
      setRegistrationResult("success");
      setFile(null);
      setNewData(
        structuredClone({
          appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
          licenseTypeId: (() =>
            mode === "add" ? (window.location.pathname.includes("/republican") ? 1 : 2) : "")(),
          licenseTypeIdName: (() =>
            mode === "add"
              ? window.location.pathname.includes("/republican")
                ? "Республиканское"
                : "Международное"
              : "")(),
        }),
      );
      dispatch(clearExchangeAppData());
    }
  };

  const handleFile = (e) => {
    if (e) {
      if (e.target.files[0]) {
        setFile(e.target.files[0]);
      }
    }
  };

  const clearFile = (e) => {
    setFile("");
    e.preventDefault();
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!!getValues("licenseNum")) {
      if (getValues("licenseNum").includes("/")) {
        setError("licenseNum", { type: "manual", message: 'Значение не может содержать "/"' });
      } else {
        dispatch(getCertificateInfoByNumExchange(getValues("licenseNum"), newData.licenseTypeId));
      }
    }
  };

  const handleCloseApp = () => {
    setFile(null);
    setNewData(
      structuredClone({
        appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
      }),
    );
    dispatch(clearExchangeAppData());
    navigate("/exchange-certificates");
    setHeaderText("");
    setErrorText("");
  };

  const handleDownloadFile = async (e) => {
    if (e) {
      e.preventDefault();
      if (await trigger()) {
        setIsLoadingModal(true);
        if (newData.licenseTypeId === 1) {
          setValue("validTypeId", "");
          setValue("validZoneId", "");
        }
        const newStatement = { ...getValues() };
        for (const key in newStatement) {
          if (key.includes("Date") && key !== "appDate") {
            newStatement[key] =
              newStatement[key] && newStatement[key].includes("-")
                ? newStatement[key].split("-").reverse().join(".")
                : newStatement[key];
          }
        }

        const request = await fetchWithToken(
          MAIN_URL + PORT + API_PRINT_EXCHANGE_CERTIFICATE_APP + newData.licenseTypeId,
          {
            method: "POST",
            body: JSON.stringify({ ...newStatement, exchangeReason: getValues("exchangeReasonName") }),
          },
        );
        if (request.status !== 200) {
          setShowResultModal(!showResultModal);
          setRegistrationResult("error");
          setIsLoadingModal(false);
        } else {
          const formData = await request.formData();
          const fileDocx = formData.get("docx");
          const fileUrl = URL.createObjectURL(fileDocx);
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = fileDocx.name;
          link.click();
          setIsPrinted(true);
          setIsLoadingModal(false);
        }
      }
    }
  };

  const handleLicenseSearchValidation = (err) => {
    if (err) {
      setNewData(
        structuredClone({
          appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
          licenseTypeId: (() =>
            mode === "add" ? (window.location.pathname.includes("/republican") ? 1 : 2) : "")(),
          licenseTypeIdName: (() =>
            mode === "add"
              ? window.location.pathname.includes("/republican")
                ? "Республиканское"
                : "Международное"
              : "")(),
        }),
      );
      setError("licenseNum", { type: "manual", message: err });
    } else {
      clearErrors("licenseNum");
    }
  };

  useEffect(() => {
    const asyncWatch = async (value, { name, type }) => {
      if (newData[name] !== value[name]) {
        newData[name] = value[name];
        if (name === "agentOblastId" || name === "agentRayonId" || name === "agentGorodId") {
          setOptions({ ...options, represent: await setOptionsRepresentPerson(value, name) });
          if (name === "agentOblastId") {
            setValue("agentRayonId", undefined);
            setValue("agentGorodId", undefined);
          }
        }
        if (name === "licenseNum") {
          setOptions({ ...options, ...setDisabledButtonStatus(value[name], newData.licenseTypeId) });
        }

        if (name === "exchangeReason") {
          if (value[name] === "1")
            setOptions({
              ...options,
              interested: {
                ...options.interested,
                inputsOptions: {
                  ...options.interested.inputsOptions,
                  name: { ...options.interested.inputsOptions.name, fieldModeView: true },
                  surname: { ...options.interested.inputsOptions.surname, fieldModeView: true },
                  midname: { ...options.interested.inputsOptions.midname, fieldModeView: true },
                  docType: { ...options.interested.inputsOptions.docType, fieldModeView: false },
                  docSeries: { ...options.interested.inputsOptions.docSeries, fieldModeView: false },
                  docNum: { ...options.interested.inputsOptions.docNum, fieldModeView: false },
                  docDateIssue: { ...options.interested.inputsOptions.docDateIssue, fieldModeView: false },
                  docDepartment: { ...options.interested.inputsOptions.docDepartment, fieldModeView: false },
                },
              },
            });
          if (value[name] === "2")
            setOptions({
              ...options,
              interested: {
                ...options.interested,
                inputsOptions: {
                  ...options.interested.inputsOptions,
                  name: { ...options.interested.inputsOptions.name, fieldModeView: false },
                  surname: { ...options.interested.inputsOptions.surname, fieldModeView: false },
                  midname: { ...options.interested.inputsOptions.midname, fieldModeView: false },
                  docType: { ...options.interested.inputsOptions.docType, fieldModeView: false },
                  docSeries: { ...options.interested.inputsOptions.docSeries, fieldModeView: false },
                  docNum: { ...options.interested.inputsOptions.docNum, fieldModeView: false },
                  docDateIssue: { ...options.interested.inputsOptions.docDateIssue, fieldModeView: false },
                  docDepartment: { ...options.interested.inputsOptions.docDepartment, fieldModeView: false },
                },
              },
            });
          if (value[name] === "3")
            setOptions({
              ...options,
              interested: {
                ...options.interested,
                inputsOptions: {
                  ...options.interested.inputsOptions,
                  name: { ...options.interested.inputsOptions.name, fieldModeView: false },
                  surname: { ...options.interested.inputsOptions.surname, fieldModeView: false },
                  midname: { ...options.interested.inputsOptions.midname, fieldModeView: false },
                  docType: { ...options.interested.inputsOptions.docType, fieldModeView: true },
                  docSeries: { ...options.interested.inputsOptions.docSeries, fieldModeView: true },
                  docNum: { ...options.interested.inputsOptions.docNum, fieldModeView: true },
                  docDateIssue: { ...options.interested.inputsOptions.docDateIssue, fieldModeView: true },
                  docDepartment: { ...options.interested.inputsOptions.docDepartment, fieldModeView: true },
                },
              },
            });
        }
      }
    };
    const subscription = watch(asyncWatch);
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (mode === "add") {
      Object.values(options).map((item) => {
        item.inputsOptions &&
          Object.values(item.inputsOptions).map((elem) => {
            if (elem.defaultValue) {
              setValue(elem.key, elem.defaultValue);
            }
          });
      });
    } else {
      Object.values(options).map((item) => {
        item.inputsOptions &&
          Object.values(item.inputsOptions).map((elem) => {
            if (elem.hasOwnProperty("defaultValue")) {
              newData[elem.key] = elem.defaultValue;
            }
          });
        setNewData(structuredClone(newData));
      });
    }
  }, [options]);

  useEffect(() => {
    if (Object.values(dictionaryReducer.identificationDocuments).length > 0) {
      setDocOptionsRepresentFromDictionaries(dictionaryReducer.identificationDocuments);
    }
    if (Object.values(dictionaryReducer.allOblast).length > 0) {
      setOblOptionsFromDictionaries(dictionaryReducer.allOblast);
    }
    if (Object.values(dictionaryReducer.allMedConditions).length > 0) {
      setMedicalConditionOptions(dictionaryReducer.allMedConditions);
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (Object.values(dictionaryReducer.identificationDocuments).length > 0) {
      setDocOptionsRepresentFromDictionaries(dictionaryReducer.identificationDocuments);
    }
    if (Object.values(dictionaryReducer.allOblast).length > 0) {
      setOblOptionsFromDictionaries(dictionaryReducer.allOblast);
    }
    if (Object.values(dictionaryReducer.allMedConditions).length > 0) {
      setMedicalConditionOptions(dictionaryReducer.allMedConditions);
    }
  }, []);

  useEffect(() => {
    async function setoptions(value, key) {
      setOptions({
        ...options,
        represent: await setOptionsRepresentPerson(value, key),
      });
    }
    if (mode === "view") {
      if (Object.values(exchangeCertificatesReducer.newAppExchangeCertificates).length > 0) {
        setNewData({ ...newData, ...exchangeCertificatesReducer.newAppExchangeCertificates });
        if (newData.viewFileName) {
          setViewFileName(newData.viewFileName);
        }
        setOptions({
          ...options,
          represent: setDefaultOptionsRepresent(
            mode,
            !!exchangeCertificatesReducer.newAppExchangeCertificates?.agent,
            !!exchangeCertificatesReducer.newAppExchangeCertificates?.agentOblastId,
          ),
          interested:
            exchangeCertificatesReducer.newAppExchangeCertificates?.licenseTypeId === 1
              ? interestedPersonRepublican
              : interestedPersonInternational,
          header: setHeaderFieldsByCertificateType(
            exchangeCertificatesReducer.newAppExchangeCertificates?.licenseTypeId,
          ),
        });
        if (!!exchangeCertificatesReducer.newAppExchangeCertificates.agentOblastId) {
          setoptions(exchangeCertificatesReducer.newAppExchangeCertificates, "agentOblastId");
        }
        if (!!exchangeCertificatesReducer.newAppExchangeCertificates.agentRayonId) {
          setoptions(exchangeCertificatesReducer.newAppExchangeCertificates, "agentRayonId");
        }
      }
    } else {
      if (Object.values(exchangeCertificatesReducer.newAppExchangeCertificates).length > 0) {
        setNewData({ ...newData, ...exchangeCertificatesReducer.newAppExchangeCertificates });
        for (let item in exchangeCertificatesReducer.newAppExchangeCertificates) {
          if (exchangeCertificatesReducer.newAppExchangeCertificates[item]) {
            setValue(item, exchangeCertificatesReducer.newAppExchangeCertificates[item]);
          }
        }
      }
    }

    setIsLoading(false);
  }, [exchangeCertificatesReducer.newAppExchangeCertificates]);

  useEffect(() => {
    handleLicenseSearchValidation(
      exchangeCertificatesReducer.wrongTypeErr || exchangeCertificatesReducer.licenseNotExistErr,
    );
  }, [exchangeCertificatesReducer.wrongTypeErr, exchangeCertificatesReducer.licenseNotExistErr]);

  useEffect(() => {
    if (mode === "view") {
      dispatch(getExchangeAppDataById(window.location.pathname.split("/").at(-1)));
    } else {
      setOptions({
        ...options,
        header: setHeaderFieldsByCertificateType(window.location.pathname.includes("/republican") ? 1 : 2),
        interested: (() =>
          window.location.pathname.includes("/republican")
            ? interestedPersonRepublican
            : interestedPersonInternational)(),
        represent: setDefaultOptionsRepresent(mode, false, false),
      });
    }
  }, []);

  useEffect(() => {
    if (mode === "view") setOptions({ ...options, represent: setGridsByMode(mode) });
  }, [mode]);

  useEffect(() => {
    setValue("isNeedToPaySelector", newData.isNeedToPaySelector);
  }, []);

  return (
    <>
      <div className={styles["content-container"]}>
        <h1 className={styles["main-text"]}>Заявление</h1>
        <p className={styles["description-text"]}>
          {newData.licenseTypeId === 1
            ? "об обмене удостоверения на право управления моторным маломерным судном, мощность двигателя которого превышает 3,7 киловатта (5 лошадиных сил)"
            : "об обмене международного удостоверения на право управления прогулочным судном"}
        </p>
        {isLoading ? (
          <div className={`d-flex flex-column align-items-center `}>
            <ProgressBar
              height="80"
              width="80"
              ariaLabel="progress-bar-loading"
              wrapperStyle={{}}
              wrapperClass="progress-bar-wrapper"
              borderColor="#D2AF8E"
              barColor="#BC8653"
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit(resolveSubmit)}>
            <UniversalHeader
              options={options.header}
              mode={mode}
              styles={styles}
              register={register}
              unregister={unregister}
              control={control}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              newData={newData}
              errors={errors}
              handleCustomButton={handleSearch}
            />
            <UniversalInputComponent
              options={options.interested}
              mode={mode}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
            />
            <UniversalInputComponent
              options={options.represent}
              mode={mode}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
            />
            <UniversalInputComponent
              options={options.medCondition}
              mode={"view"}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
            />
            {mode === "add" && (
              <div className={styles["exam-type-block"]}>
                <InputsCreatorUniversal
                  option={isNeedToPaySelector}
                  styles={styles}
                  register={register}
                  newData={newData}
                  control={control}
                  setValue={setValue}
                  mode={mode}
                  errors={errors}
                  clearErrors={clearErrors}
                />
              </div>
            )}
            <AppFooterRHF
              mode={mode}
              register={register}
              control={control}
              setValue={setValue}
              clearErrors={clearErrors}
              errors={errors}
              newData={newData}
              styles={styles}
              handleFile={handleFile}
              clearFile={clearFile}
              fileName={file?.name}
              fileDownloadApi={downloadAPI}
              viewFileName={viewFileName}
            />
            <ButtonsBlock
              closeBtnText={!isPrinted && "Закрыть"}
              saveBtnText={mode === "add" && "Зарегистрировать"}
              extraBtnText={mode === "add" && printAccess && "Распечатать"}
              handleCloseBtn={handleCloseApp}
              handleExtraBtn={handleDownloadFile}
            />
          </form>
        )}
      </div>
      {showBillContractModal && (
        <QRModalWindow
          show={showBillContractModal}
          setShow={setShowBillContractModal}
          billId={serviceBill.id}
          billQRurl={serviceBill.QRurl}
          onClose={serviceBill.onClose}
        />
      )}
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={handleCloseApp}
          errorText={errorText}
          headerTextExternal={headerText}
          handleCloseExternal={() => {
            setHeaderText("");
            setErrorText("");
          }}
        />
      )}
      <LoaderWithOverlay isLoading={isLoadingModal} />
    </>
  );
}
